<template>
  <div id="app">
    <gHeader/>
    <gNav/>
    <main>
      <router-view/>
    </main>
    <gFooter/>
    <aside class="cmn-bg">
      <div class="cmn-bg_list"></div>
      <div class="cmn-bg_list"></div>
      <div class="cmn-bg_list"></div>
      <div class="cmn-bg_list"></div>
    </aside>
    <aside class="cmn-loading">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </aside>
    <!-- <video id="video" src="./assets/mov/mov.mp4" muted></video> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="sass">
  @import "./assets/css/common.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue